import { 
  FETCHING_TRANSLATION_TABLES,
  FETCH_TRANSLATION_TABLES_SUCCESS,
  BACKUP_TRANSLATION_TABLES,
  RESTORE_TRANSLATION_TABLES,
  ADD_UNCONFIRMED_TRANSLATION_TABLE,
  DELETE_UNCONFIRMED_TRANSLATION_TABLE
} from "./ProfileTranslationTablesConstants";
import { FETCH_PROFILE_COMPLETE, RESET_PROFILE } from "redux/profiles/ProfilesConstants";
import { ADD_TRANSLATION_TABLE_TO_PROFILE } from '../translationTable/TranslationTableConstants';

const initialState = { 
  fetchingTranslationTables: false,
  translationTables: [],
  unconfirmedTranslationTables: [],
  backupTranslationTables: []
};

const ProfileTranslationTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_TRANSLATION_TABLES:
      return { ...state, fetchingTranslationTables: true };
    case FETCH_TRANSLATION_TABLES_SUCCESS:
      return { ...state, fetchingTranslationTables: false, translationTables: action.translationTables };
    case ADD_UNCONFIRMED_TRANSLATION_TABLE:
      return { ...state, unconfirmedTranslationTables: [...state.unconfirmedTranslationTables, action.translationTable] };
    case ADD_TRANSLATION_TABLE_TO_PROFILE:
      return {
        ...state,
        translationTables: [...state.translationTables, ...state.unconfirmedTranslationTables],
        unconfirmedTranslationTables: []
      };
    case FETCH_PROFILE_COMPLETE:
      return { ...state, translationTables: action.profile.map.translationsId.map( tTableId => ({ id: tTableId }))};
    case RESET_PROFILE:
      return { ...initialState };
    case BACKUP_TRANSLATION_TABLES:
      return { ...state, backupTranslationTables: state.unconfirmedTranslationTables.map(e => ({ ...e })) };
    case RESTORE_TRANSLATION_TABLES:
      return { ...state, unconfirmedTranslationTables: state.backupTranslationTables.map(e => ({ ...e })) };
    case DELETE_UNCONFIRMED_TRANSLATION_TABLE:
      return { ...state, unconfirmedTranslationTables: state.unconfirmedTranslationTables.filter(tt => tt.id != action.ttId), translationTables: state.translationTables.filter(tt => tt.id != action.ttId) };
    default:
      return state;
  }
};

export default ProfileTranslationTablesReducer;



// WEBPACK FOOTER //
// ./src/redux/profileTranslationTables/ProfileTranslationTablesReducer.js